import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import get from "lodash/get";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import { instance } from "../../../../../Actions/AxiosInstance";
import emptylist from "../../../../../Assets/Svg/illustration-no-policy.svg";
import { DatePickerComponent } from "../../../../../Component/Custom";
import DefaultComp from "../../../../../Component/DefaultComp/Defaultstatecomp";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import TextArea from "../../../../../Component/Material-ui/TextArea";
import { ErrorMessages } from "../../../../../Constants";
import {
  convertDateForBackend,
  formatEJ2CalenderDate,
  getEJ2CalenderDateFormat,
  getFormattedDate,
} from "../../../../../Utils";
import { addDays } from "../../../../../Utils/dates";

const resign = { displayvalue: 1, displayname: "Resignation" };
const termin = { displayvalue: 2, displayname: "Termination" };

export default class Resignation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmployee: false,
      AllResignTypes: [resign, termin],
      AllReasons: [],
      form: { ...POST_DATA },
      requestForRevisedExitDate: false,
      exitDate: "",
      dataReceived: false,
      exitpolicyDetails: null,
    };
    this.updateForm = this.updateForm.bind(this);
    this.Submit = this.Submit.bind(this);
    this.setIsRevised = this.setIsRevised.bind(this);
  }

  componentDidMount() {
    const { colleagueid } = this.props;
    instance.post("exit/getreason", { isactive: true }).then((resp) => {
      this.setState({
        AllReasons: resp.data.result,
      });
    });
    const URL = "exit/employeeexitpolicy";
    const data = colleagueid ? { employeeid: colleagueid } : {};
    instance
      .post(URL, data)
      .then((resp) => {
        this.setState({
          exitpolicyDetails: get(resp, "data.result[0]", ""),
          dataReceived: true,
        });
      })
      .catch((e) => {
        console.log("e: ", e);
      });
  }

  updateForm(key, value) {
    const { form } = this.state;
    if (key == "requestrevisetype" && !value) {
      form[key] = null;
    }
    form[key] = value;
    this.setState({ form });
  }

  revisedDateChange = (event) => {
    const { form } = this.state;
    form.requestrevisedate = event.value;
    this.setState({ form });
  };

  setIsRevised() {
    this.setState({
      requestForRevisedExitDate: !this.state.requestForRevisedExitDate,
    });
  }

  Submit() {
    const { form } = this.state;
    const data = form;
    // data.senderid = get(this.props, "AuthenticationAction.login.employeeid", "");
    // data.sendersourceid = get(this.props, "AuthenticationAction.login.employeeid", "");
    data.sendersourceid = 1;
    data.days = get(this.state, "exitpolicyDetails.noticeperioddays", "");
    data.exitpolicyid = get(this.state, "exitpolicyDetails.exitpolicyid", "");
    data.requestrevisedate = convertDateForBackend(data.requestrevisedate);
    if (this.props.colleagueid) {
      data.employeeid = this.props.colleagueid;
    }

    if (
      !data.subscriptionexitreasonid ||
      !data.reasontypeid ||
      !data.comment ||
      (data.requestrevisetype && !data.requestrevisedate)
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    } else {
      instance
        .post("requestcenter/exitrequest", data)
        .then(() => {
          this.props.enqueueSnackbar("applied successfully", {
            variant: "success",
          });
          this.props.toggleDrawer(false);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  render() {
    const { colleagueid } = this.props;
    const {
      isEmployee,
      AllResignTypes,
      AllReasons,
      form,
      dataReceived,
      exitpolicyDetails,
    } = this.state;
    const { reasontypeid, requestrevisetype } = form;
    const noticeperioddays = get(exitpolicyDetails, "noticeperioddays", "");
    const exitDate = getFormattedDate(addDays({ days: noticeperioddays }));
    // const MandatoryIndicator = () => <span className="text-color-red"> *</span>;
    return dataReceived ? (
      exitpolicyDetails ? (
        <div className="padding20">
          {/* <p className="form-main-header text-align-center margin-bottom-16">
            Official Resignation Request
          </p> */}
          <DrawerHeader
            header="Official Resignation Request "
            isbackarrow={false}
            closeDrawer={() => this.props.toggleDrawer(false)}
          />
          <div className="">
            {colleagueid && (
              <div className="margin-top-16 ">
                <p className="new-form-sub-header">
                  Is this a Resignation or Termination Request?
                </p>
                <Select
                  isDisabled={isEmployee}
                  className="selectsearch"
                  onChange={(e) =>
                    this.updateForm("reasontypeid", e.displayvalue)
                  }
                  options={AllResignTypes}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                />
              </div>
            )}
            <div className="margin-top-16 ">
              <p className="new-form-sub-header">
                Reason for submitting request:
              </p>
              <Select
                className="selectsearch"
                onChange={(e) =>
                  this.updateForm(
                    "subscriptionexitreasonid",
                    e.subscriptionexitreasonid,
                  )
                }
                options={AllReasons.filter(
                  (x) => x.reasontypeid == reasontypeid,
                )}
                getOptionLabel={(option) => option.reason}
                getOptionValue={(option) => option.subscriptionexitreasonid}
              />
            </div>
            <div className="margin-top-15">
              {/* <div>Tell us your reason</div> */}
              <p className="new-form-sub-header">
                <FormattedMessage
                  id="LbMessage"
                  defaultMessage="Reason for request"
                />
              </p>
              <div>
                <TextArea
                  className="width100"
                  maxLength="550"
                  variant="outlined"
                  multiline
                  onChange={(e) => this.updateForm("comment", e.target.value)}
                />
              </div>
            </div>
            {/* <div className="margin-top-16 ">
                <p className="new-form-sub-header">
                  Message
                </p>
                <TextField
                  className="width100"
                  multiline
                  rowsMax="6"

                  margin="normal"
                  variant="outlined"
                />
              </div> */}
          </div>

          {get(exitpolicyDetails, "isnoticechangeallowed", "") && (
            <div className="margin-top-16 ">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={requestrevisetype}
                    onChange={() =>
                      this.updateForm("requestrevisetype", !requestrevisetype)
                    }
                    color="primary"
                  />
                }
                label={<strong>Request for revised exit date</strong>}
              />
              {requestrevisetype == true && (
                <div className="">
                  <DatePickerComponent
                    format={getEJ2CalenderDateFormat()}
                    start="Decade"
                    // onClick={() => this.dateObj.show()}
                    // ref={(date)) => (this.dateObj = date)}
                    className="selectsearch input-area-section"
                    placeholder="Revised Date"
                    allowEdit={false}
                    width={"100%"}
                    min={new Date()}
                    max={formatEJ2CalenderDate(
                      addDays({ days: noticeperioddays || 0 }),
                    )}
                    change={this.revisedDateChange}
                    value={this.state.form.requestrevisedate}
                    // change={(e) => this.updateForm("requestrevisedate", e.value)}
                  />
                  <div className="bg-color-fff6e1 note-div">
                    <p className="t-14">
                      The exit date will remain unchanged until your request has
                      been approved.
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="margin-top-16 ">
            <p className="new-form-sub-header">Notice Period</p>
            <div className="bg-color-fff6e1 note-div">
              <p className="t-14">
                As per your HR Policy rules, the official notice period is given
                below:
              </p>
              <p className="t-14 t-bold">{noticeperioddays} days</p>
            </div>
          </div>
          <p className="t-14">
            In accordance with the notice period, the official exit date is
            given below:{" "}
          </p>
          <p className="t-14 t-bold">{exitDate && exitDate}</p>

          <Button
            className="margin-top-40"
            color="primary"
            onClick={this.Submit}
            variant="contained"
          >
            SEND
          </Button>
        </div>
      ) : (
        <div className="padding20" style={{ height: "100vh" }}>
          {/* <p className="form-main-header text-align-center margin-bottom-16">
            Official Resignation Request
          </p> */}
          <DrawerHeader
            header="Official Resignation Request "
            isbackarrow={false}
            closeDrawer={() => this.props.toggleDrawer(false)}
          />
          <div style={{ height: "90vh" }} className="position-rel">
            <DefaultComp
              heading="There is no exit policy assigned"
              subheading="Kindly wait till an exit policy has been assigned"
              imageSrc={emptylist}
            />
          </div>
        </div>
      )
    ) : null;
  }
}
/* <div className="padding20">
    <p className="form-main-header text-align-center margin-bottom-16">Official Resignation Request</p>
    <div className="bg-color-fff6e1 note-div">
          <p className="t-14">No policy assigned</p>
    </div>
  </div> */

const POST_DATA = {
  senderid: null,
  sendersourceid: null,
  subscriptionexitreasonid: null,
  // reason: null,
  reasontypeid: 1,
  comment: null,
  // policyid: null,
  requestrevisetype: null,
  requestrevisedate: null,
  workflowfortypeid: 4,
  // isarchive: null
};
